import { useState } from "react";

import { useDialog } from "~/src/modules/ui-kit";

import Mapping from "./Mapping";
import Finder from "../../../../../modules/finder";
import { parameterValueSearch, useParameter } from "../../../../../modules/shared-entities";
import Button from "../../../components/Button";


export default function Adder(props) {
    const { bimClassID, parameterID } = props;

    const parameter = useParameter(parameterID);

    const [Dialog, open, close] = useDialog();

    const [values, setValues] = useState([]);

    function add(value) {
        close();
        setValues(
            (values) => [...values, value]
        );
    }

    function evict(value) {
        setValues(
            (values) => values.filter(
                (v) => v !== value
            )
        );
    }

    function addx() {
        if (parameter.data.parameter.values) {
            open();
        } else {
            add(Math.random());
        }
    }

    if (parameter.loading) return undefined;

    return (
        <>
            {
                values.map(
                    (value) => (
                        <Mapping
                            bimClassID={ bimClassID }
                            key={ value }
                            onEvict={ () => evict(value) }
                            parameterID={ parameterID }
                            value={ typeof value === "string" ? value : undefined }
                        />
                    )
                )
            }
            <Button
                onClick={ addx }
                size="small"
                style={ { whiteSpace: "nowrap" } }
                variant="outline"
            >
                add mapped value
            </Button>
            <Dialog>
                <Finder
                    moduleOptions={ { parameterID } }
                    modules={ [parameterValueSearch] }
                    onSelect={ (_, id) => add(id) }
                    placeholder="Search"
                />
            </Dialog>
        </>
    );
}
